import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';

import { ModalContext } from '@/components/Modals/Modal/config';
import {
  H3,
  StringMain,
  StringSmall,
} from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import usdPng from '/img/icons/usd-star-icon.png';
import usdWebp from '/img/icons/usd-star-icon.webp';
import wavesPng from '/img/patterns/waves.png';
import wavesWebp from '/img/patterns/waves.webp';

const EarnTonButton: FC = () => {
  const { t } = useTranslation();
  const { openModal } = useContext(ModalContext);

  return (
    <div
      onClick={() =>
        openModal({ renderKind: 'earnTonFromPartners', props: undefined })
      }
      className={css.earnTonButton}
    >
      <div className="w-full h-full flex items-center gap-2 relative z-[2]">
        <div className="aspect-square w-12 shrink-0">
          <Picture
            img={usdPng}
            webp={usdWebp}
            className="w-full h-full"
            alt="ton"
          />
        </div>
        <div className="flex flex-col min-w-0 justify-between h-full flex-1 py-[1.5px]">
          <StringMain weight="bold" className="!leadind-1.2">
            {t('Earn real money')}
          </StringMain>
          <div className="flex items-baseline gap-2 overflow-hidden">
            <H3
              weight="extrabold"
              className="!text-gold text-nowrap whitespace-nowrap shrink-0"
            >
              {t('Up to 11%')}
            </H3>
            <StringSmall
              weight="regular"
              className="whitespace-nowrap text-nowrap overflow-hidden text-ellipsis"
            >
              {t('from partner purchases')}
            </StringSmall>
          </div>
        </div>
        <ChevronIcon className="-scale-x-[1] text-white/40 w-6 h-6 shrink-0" />
      </div>
      <span className={css.leftCircleEffect}></span>
      <span className={css.rightCircleEffect}></span>
      <Picture
        img={wavesPng}
        webp={wavesWebp}
        className={css.waves}
        alt="waves"
      />
    </div>
  );
};

export { EarnTonButton };
